import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3 border-round-xl surface-100" }
const _hoisted_2 = { class: "flex mb-2 align-items-center" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = {
  key: 0,
  class: "flex"
}
const _hoisted_5 = { class: "flex-1 justify-content-center" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "flex p-2 mt-2 border-top-2 border-white" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = {
  key: 1,
  class: "py-8 text-center text-color-secondary text-sm"
}

import { computed, onMounted, ref, toRefs, watch } from 'vue';
import Chart from 'primevue/chart';

interface Props {
  title: string;
  tooltip: string;
  disciplines: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentTotalReportDisciplines',
  props: {
    title: { default: null },
    tooltip: { default: '' },
    disciplines: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const { title, tooltip, disciplines } = toRefs(props);

const colors = [
  {
    style: 'green-dark',
    hex: '#078888',
  },
  {
    style: 'green',
    hex: '#8BCFCF',
  },
  {
    style: 'blue',
    hex: '#40B3DD',
  },
  {
    style: 'orange',
    hex: '#EDA745',
  },
  {
    style: 'purple',
    hex: '#7E78D2',
  },
  {
    style: 'pink',
    hex: '#D49BC1',
  },
  {
    style: 'yellow',
    hex: '#FFD500',
  },
];

const totals = ref([]);

const totalResults = ref(0);

const chartData = ref({
  datasets: [
    {
      data: [],
      backgroundColor: [],
    },
  ],
});

watch(
  () => disciplines.value,
  () => defineTotals(),
);

onMounted(() => defineTotals());

const hasTotals = computed(() => Object.keys(disciplines.value).length);

const formattedTotalResults = computed(() => formatNumber(totalResults.value));

const defineTotals = () => {
  totalResults.value = 0;

  disciplines.value.forEach(({ total }) => (totalResults.value += total));

  const chart = {
    data: [],
    backgroundColor: [],
  };

  totals.value = disciplines.value.map(({ total, name }, key) => {
    chart.data.push(total);
    chart.backgroundColor.push(colors[key].hex);

    return {
      total,
      percent: formatPercent(total),
      name,
      style: colors[key].style,
    };
  });

  defineChartData(chart);
};

const defineChartData = (chart) => (chartData.value.datasets[0] = chart);

const formatNumber = (number: number) => new Intl.NumberFormat().format(Math.round(number));

const formatPercent = (total: number) => `${((total / totalResults.value) * 100).toFixed()}%`;

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", {
        class: "text-base text-color-secondary flex-1",
        textContent: _toDisplayString(_unref(title))
      }, null, 8, _hoisted_3),
      _withDirectives(_createVNode(_component_Icon, {
        name: "info",
        class: "text-gray-400 text-base cursor-pointer"
      }, null, 512), [
        [_directive_tooltip, _unref(tooltip)]
      ])
    ]),
    (hasTotals.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(Chart), {
            type: "doughnut",
            data: chartData.value,
            class: "attendance flex align-items-center bg-white mr-3 p-2 pt-0 border-circle"
          }, null, 8, ["data"]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totals.value, (item, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "flex gap-2 mb-2"
              }, [
                _createVNode(_component_Icon, {
                  name: "circle",
                  class: _normalizeClass(`text-color-${item.style} text-xs`)
                }, null, 8, ["class"]),
                _createElementVNode("span", {
                  class: _normalizeClass(`text-color-${item.style} text-xs flex-1`),
                  textContent: _toDisplayString(item.name)
                }, null, 10, _hoisted_6),
                _createElementVNode("span", {
                  class: _normalizeClass(`text-color-${item.style} font-bold text-sm`),
                  textContent: _toDisplayString(item.total)
                }, null, 10, _hoisted_7),
                _createElementVNode("span", {
                  class: _normalizeClass(`text-color-${item.style} text-xs text-right w-2rem`),
                  textContent: _toDisplayString(item.percent)
                }, null, 10, _hoisted_8)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_9, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-color-grey text-xs flex-1" }, "Total", -1)),
              _createElementVNode("span", {
                class: "text-color-grey font-bold text-sm",
                textContent: _toDisplayString(formattedTotalResults.value)
              }, null, 8, _hoisted_10)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_11, "No Discipline Totals Available"))
  ]))
}
}

})